import React, { useEffect, useState } from "react";
import { fetchEmployeeAvatar } from "../../utils/api";

export default function AuthenticatedAvatar({
  employeeId,
  cacheKey,
  alt = "",
  className = "",
  fallback = null,
}) {
  const [objectUrl, setObjectUrl] = useState(null);

  useEffect(() => {
    let active = true;
    let nextObjectUrl = null;

    setObjectUrl(null);
    if (!employeeId) return undefined;

    fetchEmployeeAvatar(employeeId)
      .then((url) => {
        nextObjectUrl = url;
        if (active) setObjectUrl(url);
      })
      .catch(() => {
        if (active) setObjectUrl(null);
      });

    return () => {
      active = false;
      if (nextObjectUrl) URL.revokeObjectURL(nextObjectUrl);
    };
  }, [employeeId, cacheKey]);

  if (!objectUrl) return fallback;

  return (
    <img
      src={objectUrl}
      alt={alt}
      className={className}
      onError={() => setObjectUrl(null)}
    />
  );
}
